module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "inline-form-group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tryb kafelków",
      "error": _vm.errors['tiles_mode']
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.tiles_mode),
      callback: function($$v) {
        _vm.$set(_vm.form, "tiles_mode", $$v)
      },
      expression: "form.tiles_mode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tryb kalendarza",
      "error": _vm.errors['calendar_mode']
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.calendar_mode),
      callback: function($$v) {
        _vm.$set(_vm.form, "calendar_mode", $$v)
      },
      expression: "form.calendar_mode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.sections), function(section, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (section.name_pl || 'Nowa sekcja')),
        "items": _vm.form.sections,
        "errors": _vm.checkForErrors(_vm.errors.sections, [i]),
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "sections", $event)
        }
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Tytuł sekcji",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i][_vm.addLanguageSuffix('name')]
      }
    }, [_c('el-input', {
      model: {
        value: (section[_vm.addLanguageSuffix('name')]),
        callback: function($$v) {
          _vm.$set(section, _vm.addLanguageSuffix('name'), $$v)
        },
        expression: "section[addLanguageSuffix('name')]"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Kolor tła",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i]['bg_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (section.bg_color),
        callback: function($$v) {
          _vm.$set(section, "bg_color", $$v)
        },
        expression: "section.bg_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Wyświetlaj w kafelkach",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i]['show_in_tiles']
      }
    }, [_c('el-switch', {
      model: {
        value: (section.show_in_tiles),
        callback: function($$v) {
          _vm.$set(section, "show_in_tiles", $$v)
        },
        expression: "section.show_in_tiles"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Wyświetlaj w kalendarzu",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i]['show_in_calendar']
      }
    }, [_c('el-switch', {
      model: {
        value: (section.show_in_calendar),
        callback: function($$v) {
          _vm.$set(section, "show_in_calendar", $$v)
        },
        expression: "section.show_in_calendar"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Typ wydarzeń",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i]['event_type']
      }
    }, [_c('el-select', {
      staticClass: "fluid",
      attrs: {
        "filterable": "",
        "placeholder": "Typ wydarzenia"
      },
      on: {
        "change": function($event) {
          return _vm.resetTags(section)
        }
      },
      model: {
        value: (section.event_type),
        callback: function($$v) {
          _vm.$set(section, "event_type", $$v)
        },
        expression: "section.event_type"
      }
    }, _vm._l((_vm.availableTypes), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": _vm.translateType(item),
          "value": item
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Tagi",
        "error": _vm.errors.sections && _vm.errors.sections[i] && _vm.errors.sections[i]['tags']
      }
    }, [_c('el-select', {
      staticClass: "fluid",
      attrs: {
        "filterable": "",
        "multiple": "",
        "disabled": !(!!section.event_type),
        "placeholder": "Wybierz tagi"
      },
      model: {
        value: (section.tags),
        callback: function($$v) {
          _vm.$set(section, "tags", $$v)
        },
        expression: "section.tags"
      }
    }, _vm._l((_vm.tagsForType(section.event_type)), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1)], 1)], 1)], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("\n        Dodaj sekcję\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b35c2ea6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/LineupWidget.vue
// module id = 796
// module chunks = 0